import api from '../../api/apiSlice';
import { CSM } from '../../services/UsersService';

const csmApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCsms: builder.query<CSM[], void>({
      query: () => ({
        url: '/csm-contacts',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCsmsQuery } = csmApi;
